export default __webpack_public_path__ + "410b6a551786532885481eacf547a83d.png";